angular
    .module('vm.helpCenter')
    .controller('HelpCenterController', HelpCenterController);

function HelpCenterController() {
    const vm = this;

    vm.sentRequestNotificationsClosed = false;
}